export { default } from './media-loader';